import { HeadsUpBlock } from '@/components/HeadsUpBlock'

/**
 * Fallback for unknown questions.
 */
export function UnknownQuestionAnswerEditor() {
  return (
    <HeadsUpBlock title="Unknown question type">
      Please contact support.
    </HeadsUpBlock>
  )
}
